import { render, staticRenderFns } from "./VehicleDelivery.vue?vue&type=template&id=1430519e&"
import script from "./VehicleDelivery.vue?vue&type=script&lang=js&"
export * from "./VehicleDelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports